import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EActionTypes } from '../../constants/actionTypes/realtorInfo';
import { IRealtorData } from '../../types/realtorInfo';

export const setRealtorInfoRequest = actionGenerator<EActionTypes.Request>(EActionTypes.Request);
export const setRealtorInfoSuccess = actionGenerator<EActionTypes.Success, IRealtorData | null>(EActionTypes.Success);
export const setRealtorInfoFailure = actionGenerator<EActionTypes.Failure>(EActionTypes.Failure);

export type TSetListingRequest = ReturnType<typeof setRealtorInfoRequest>;
export type TSetListingSuccess = ReturnType<typeof setRealtorInfoSuccess>;
export type TSetListingFailure = ReturnType<typeof setRealtorInfoFailure>;

export type TSetRealtorInfoActions = TSetListingRequest | TSetListingSuccess | TSetListingFailure;
